import { isFunction } from 'lodash';
import { Component, createElement, Fragment } from 'react';
import { LocalizedText } from '@mews/framework';
import { ActionType, TextKey } from '@mews-commander/enums';
import { Button, ButtonProps, Dialog } from '@optimus-web/core';

export interface ConfirmationDialogActionProps {
    action?: {
        text?: string;
        title?: string;
        buttonText?: string;
        onConfirmation?: $TSFixMeFunction;
        isDanger: boolean;
        url?: string;
    };
    component: typeof Button;
    componentProps: ButtonProps;
    componentChildren: React.ReactNode;
}

type State = $TSFixMe;

class ConfirmationDialogAction extends Component<ConfirmationDialogActionProps, State> {
    state = {
        opened: false,
        confirming: false,
    };

    handleClick = () => {
        this.setState({
            opened: true,
        });
    };

    handleOnCancel = () => {
        if (!this.state.confirming) {
            this.setState({
                opened: false,
            });
        }
    };

    handleOnConfirmation = async () => {
        const { action } = this.props;
        // @ts-expect-error $TSFixMeError: Property 'onConfirmation' does not exist on type '{ text?: string | undefined; title?: string | undefined; buttonText?: ...
        const { onConfirmation } = action;

        this.setState({
            confirming: true,
        });

        if (isFunction(onConfirmation)) {
            try {
                await onConfirmation();
            } finally {
                this.setState((prevState: $TSFixMe) => ({
                    confirming: !prevState.confirming,
                    opened: false,
                }));
            }
        }

        this.setState((prevState: $TSFixMe) => ({
            confirming: !prevState.confirming,
            opened: false,
        }));
    };

    render() {
        const { action, component, componentProps, componentChildren } = this.props;
        // @ts-expect-error $TSFixMeError: Property 'isDanger' does not exist on type '{ text?: string | undefined; title?: string | undefined; buttonText?: string...
        const { isDanger, buttonText, text, title, icon, disabled, url } = action;

        const actions: ButtonProps[] = [
            {
                children: <LocalizedText textKey={TextKey.GoBack} />,
                onClick: this.handleOnCancel,
                variant: 'ghost',
                type: 'submit',
            },
            {
                children: buttonText,
                onClick: this.handleOnConfirmation,
                variant: isDanger ? 'destructive' : 'primary',
                type: 'submit',
            },
        ];

        return (
            <Fragment>
                {createElement(
                    component,
                    {
                        title: buttonText,
                        icon,
                        onClick: this.handleClick,
                        disabled,
                        ...componentProps,
                    },
                    componentChildren
                )}
                <Dialog
                    active={this.state.opened}
                    title={title}
                    actions={actions}
                    loading={this.state.confirming}
                    onClose={title ? this.handleOnCancel : undefined}
                    data-action-type={ActionType.ConfirmationDialog}
                    data-action-url={url}
                >
                    {text}
                </Dialog>
            </Fragment>
        );
    }
}

export default ConfirmationDialogAction;
